import { render, staticRenderFns } from "./TabRanking.vue?vue&type=template&id=09425225&scoped=true&"
import script from "./TabRanking.vue?vue&type=script&lang=js&"
export * from "./TabRanking.vue?vue&type=script&lang=js&"
import style0 from "./TabRanking.vue?vue&type=style&index=0&id=09425225&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09425225",
  null
  
)

export default component.exports